import { z } from 'zod';

export type HttpMethod = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
export type RouteAuth = 'session' | 'public' | 'webhook';

export interface RouteDefinition<
  TParams extends z.ZodType | undefined = z.ZodType | undefined,
  TQuery extends z.ZodType | undefined = z.ZodType | undefined,
  TBody extends z.ZodType | undefined = z.ZodType | undefined,
  TResponse extends z.ZodType | undefined = z.ZodType | undefined,
> {
  operationId: string;
  method: HttpMethod;
  /** Path relative to /api/v1, using :param segments. */
  path: string;
  summary: string;
  tag: string;
  auth: RouteAuth;
  params?: TParams;
  query?: TQuery;
  body?: TBody;
  /** Response body schema; undefined means 204 No Content. */
  response?: TResponse;
  successStatus: 200 | 201 | 202 | 204;
  /** Mutating command that accepts an Idempotency-Key header. */
  idempotent?: boolean;
}

export function defineRoute<
  TParams extends z.ZodType | undefined = undefined,
  TQuery extends z.ZodType | undefined = undefined,
  TBody extends z.ZodType | undefined = undefined,
  TResponse extends z.ZodType | undefined = undefined,
>(route: RouteDefinition<TParams, TQuery, TBody, TResponse>) {
  return route;
}

export type InferOrVoid<T> = T extends z.ZodType ? z.infer<T> : void;
export type InputOf<T> = T extends z.ZodType ? z.input<T> : void;

export const IdParam = z.object({ id: z.uuid() });
export const IdChildParam = z.object({ id: z.uuid(), childId: z.uuid() });
